import React from 'react';

export type WidgetFullscreenUrlSyncContextValue = {
  fullscreenWidgetId?: string;
  setFullscreenWidgetIdInUrl: (nextWidgetId?: string) => void;
  /**
   * Keeps the `fullscreenWidgetId` widget in fullscreen (Slack embed): its fullscreen controls are
   * hidden and neither the controls nor Escape restore it.
   */
  fullscreenLocked?: boolean;
};

const noop = () => {};

export const WidgetFullscreenUrlSyncContext =
  React.createContext<WidgetFullscreenUrlSyncContextValue>({
    fullscreenWidgetId: undefined,
    setFullscreenWidgetIdInUrl: noop,
  });

export const useWidgetFullscreenUrlSync = () => {
  return React.useContext(WidgetFullscreenUrlSyncContext);
};
